module.exports = __webpack_public_path__ + "img/goldregen-2020-096.c791d2a2.jpg";